type BadgeColor = "orange" | "green" | "gray" | "red" | undefined;

interface StatusResult {
  color: BadgeColor;
  label: string;
}

/**
 * Returns the badge color and label for a deployed course instance status.
 * Used in: view-deployed-course-instance
 */
export const getDeployedCourseStatus = (status: number | undefined | null): StatusResult => {
  if (status === 1) {
    return { color: "green", label: "Active" };
  }
  if (status === 3) {
    return { color: "red", label: "Failed" };
  }
  if (status === 2) {
    return { color: "gray", label: "In-progress" };
  }
  if (status === 4) {
    return { color: "gray", label: "Deleting" };
  }
  if (status === 0) {
    return { color: "gray", label: "Expired" };
  }
  return { color: "gray", label: "Expired" };
};
